export class ChangePassword {
  public constructor() {}

  public userId: string | undefined;
  public oldPassword: string | undefined;
  public oldPasswordErrorMessage: string | undefined;
  public newPassword: string | undefined;
  public newPasswordErrorMessage: string | undefined;
  public confirmPassword: string | undefined;
  public confirmPasswordErrorMessage: string | undefined;
}
